import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { baseUrl } from 'src/environments/environment';
import { Branch } from '../_models/branch.model';

@Injectable({
  providedIn: 'root'
})
export class BranchService {

  branchesUrl =  'api/CenterBranches';

  constructor(private http: HttpClient) { }

  getAllBranches(): Observable<any> {
    return this.http.get(this.branchesUrl);
  }

  getBranchById(id): Observable<any>{
    return this.http.get(`${this.branchesUrl}/${id}`)
  }

  addNewBranch(branch: Branch): Observable<any>{
    const formData = new FormData();
    branch.logoForm && formData.append('logoForm', branch.logoForm, branch.logoForm.name);
    formData.append('name', branch.name);
    formData.append('arName', branch.arName);
    formData.append('address', branch.address);
    formData.append('arAddress', branch.arAddress);
    formData.append('phone', branch.phone);
    formData.append('email', branch.email);
    formData.append('areaId', branch.areaId.toString());
    formData.append('cityId', branch.cityId.toString());
    formData.append('isActive', branch.isActive.toString());
    formData.append('centerId', branch.centerId.toString());

    return this.http.post(this.branchesUrl, formData);
  }

  updateBranch(branch: Branch){
    const formData = new FormData();
    branch.logoForm && formData.append('logoForm', branch.logoForm, branch.logoForm.name);
    formData.append('id', branch.id.toString());
    formData.append('name', branch.name);
    formData.append('arName', branch.arName);
    formData.append('address', branch.address);
    formData.append('arAddress', branch.arAddress);
    formData.append('phone', branch.phone);
    formData.append('email', branch.email);
    formData.append('areaId', branch.area.id.toString());
    formData.append('cityId', branch.city.id.toString());
    formData.append('isActive', branch.isActive.toString());
    formData.append('centerId', branch.centerId.toString());

    return this.http.put(this.branchesUrl, formData);
  }

  getBranchesBYCenterId(centerId: number): Observable<any>{
    return this.http.get(`api/CenterBranches/GetAllByCenterId/${centerId}`)
  }

  deleteBranch(id: number): Observable<any>{
    return this.http.delete(`${this.branchesUrl}/${id}`);
  }

  searchByName(centerId, branchName) {
    return this.http.get(`${this.branchesUrl}/SearchByName/${centerId}/${branchName}`);
  }
}
